import {
  AccessPermissionInterface,
  AccessPermissionListInterface,
  CreateEntitlementGroupInterface,
  CreateRoleInterface,
  EntitlementGroupInterface,
  EntitlementGroupListInterface,
  EntitlementListInterface,
  RoleInterface,
  RoleListInterface,
  UpdateEntitlementGroupInterface,
  UpdateRoleInterface
} from '@thro-types/access-handler';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export const getEntitlementGroups = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<EntitlementGroupListInterface>(
      '/access-handler/v1/entitlement-groups',
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getEntitlements = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<EntitlementListInterface>(
      '/access-handler/v1/entitlements',
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createEntitlementGroup = async (
  data: CreateEntitlementGroupInterface,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post<EntitlementGroupInterface>(
      '/access-handler/v1/entitlement-groups',
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateEntitlementGroup = async (
  id: number,
  data: UpdateEntitlementGroupInterface,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch<EntitlementGroupInterface>(
      `/access-handler/v1/entitlement-groups/${id}`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteEntitlementGroup = async (id: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.delete<EntitlementGroupInterface>(
      `/access-handler/v1/entitlement-groups/${id}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getAccessPermissions = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<AccessPermissionListInterface>(
      '/access-handler/v1/access-permissions',
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createAccessPermission = async (
  data: { name: string },
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post<AccessPermissionInterface>(
      '/access-handler/v1/access-permissions',
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateAccessPermission = async (
  id: number,
  data: { name: string },
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch<AccessPermissionInterface>(
      `/access-handler/v1/access-permissions/${id}`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteAccessPermission = async (id: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.delete<AccessPermissionInterface>(
      `/access-handler/v1/access-permissions/${id}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getRoles = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<RoleListInterface>('/access-handler/v1/roles', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createRole = async (data: CreateRoleInterface, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.post<RoleInterface>('/access-handler/v1/roles', data, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateRole = async (
  id: number,
  data: UpdateRoleInterface,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch<RoleInterface>(
      `/access-handler/v1/roles/${id}`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteRole = async (id: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.delete<RoleInterface>(`/access-handler/v1/roles/${id}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
